<template>
   <div v-bind:class="['statusbar', { 'purplebar': status===4, 'greenbar': status===3 || status===1, 'redbar': status===2 }]">
    <span class="icon"></span>
    <div class="cont" v-if="type==='0'">
        <div class="title" v-if="status===4">支付成功，正在审核！</div>
        <div class="title" v-if="status===3">审核通过，即刻发券！</div>
        <div class="title" v-if="status===2">非常抱歉，购券失败！</div>
        <div class="msg" v-if="status===4">您所提交的购券信息正在审核，预计需要1个工作日，您可到<router-link class="link" to="/purchasecoupon/history">购券历史页</router-link>查看审核进度，若有疑问请联系企业客服400-000-0777</div>
        <div class="msg" v-if="status===3">您所提交的购券信息已通过审核，您可到<router-link class="link" to="/sendcoupon/sendbyphone">发券页</router-link>即刻发券！</div>
        <div class="msg" v-if="status===2">失败原因可能是由于网络环境不稳定导致的支付失败，您可到<router-link class="link" to="/purchasecoupon/history">购券历史页</router-link>尝试重新支付，如有其他问题请联系审核人员</div>
    </div>
    <div class="cont" v-if="type==='1'">
        <div class="title" v-if="status===1">充值成功！</div>
        <div class="title" v-if="status===2">充值失败！</div>
        <div class="msg" v-if="status===1">您可到<router-link class="link" to="/purchasecoupon/purchase">购券页</router-link>即刻购券</div>
        <div class="msg" v-if="status===2">请继续充值</div>
    </div>

   </div>
</template>

<script>
export default {
  name: 'payStatusBar',
  props: {
    status: Number,
    type: String// 0订单支付，1充值
  }
}
</script>

<style lang="stylus"  scoped >
    .statusbar{
        background-color: #eaefff;
        margin-right: 20px;
        margin-bottom: 30px;
        .icon{
            width: 60px;
            height: 60px;
            display: inline-block;
            margin-left: 40px;
            margin-top: 36px;
        }
    }
    .purplebar{
        background-color:#EAEFFF;
        .icon{
            background: url('../../../images/tips_ic_shenhe.png');
            background-size: 100% auto;
        }
    }
    .greenbar{
        background: #EDF8F2;
        .icon{
            background: url('../../../images/tips_ic_right.png');
            background-size: 100% auto;
        }
    }
    .redbar{
        background: #FFEBEB;
        .icon{
           background: url('../../../images/tips_ic_warning.png');
           background-size: 100% auto;
        }
    }
    .cont{
        position: relative;
        top: -8px;
        display: inline-block;
        margin-left: 20px;
        .title{
            font-size: 24px;
            color: #333;
            border: none;
            padding-left:0px;
        }
        .msg{
            font-size: 14px;
            color: #666;
            margin-bottom:36px;
        }
        .link{
            text-decoration: none;
            color: #FC6F53;
        }
    }
</style>
